/* 国际化zh_cn */

module.exports = {
  // 主导航
  mainNav: {
    nIndex: '首页',
    nVipCenter: '会员中心',
    nRecharge: '充值兑换'
  },
  // 和用户登录注册忘记密码相关
  userOperate: {
    emailHolder: '请输入邮箱',
    pswHolder: '请输入密码',
    codeHolder: '请输入验证码',
    checkpassHolder: '请再次输入密码',
    identHolder: '请输入身份证号码',
    loginText: '登录',
    forgetText: '忘记密码',
    registerText: '注册',
    loginTips: '第三方平台账号，请先到游戏内进行绑定',
    loginSuccess: '登录成功',
    emptyEmail: '邮箱账号不能为空',
    emptyPsw: '密码不能为空',
    emptyCode: '请输入四位图形验证码',
    emptyCodeNum: '请输入四位数字验证码',
    validEmail: '请输入合法的邮箱',
    validEmailLen: '请输入6-40位数字或字母',
    validPsw: '请输入6-30位数字或字母',
    noSamePsw: '两次密码不一致',
    emailTitle: '邮箱账号',
    pswTitle: '密码',
    newPswTitle: '新密码',
    checkpassTitle: '确认密码',
    codeTitle: '验证码',
    readAgre: '我已阅读并同意',
    agreement: '《用户注册协议》',
    goLogin: '去登录',
    hasAccount: '已有账号',
    readAndAgree: '请阅读并同意《用户注册协议》！',
    sendcodeSuccess: '验证码发送成功，请去邮箱查看！',
    forgetStep: {
      stepone: '第一步：输入龙图账号',
      steptwo: '第二步： 验证安全信息',
      stepthree: '第三步：重置登录密码',
      stepfour: '第四步：密码重置成功'
    },
    nobindTips: '未绑定邮箱请使用facebook联系客服进行找回密码',
    sendEmail: '发送验证码',
    nextStep: '下一步',
    passEmail: '通过邮箱进行安全验证',
    newPassSuccess: '新密码设置成功，请重新登录',
    loginPlatform: '登录平台',
    confirmText: '确定',
    loadingText: '注册中，请稍后......',
    registerSuccess: '恭喜成功完成账号注册 <br/> 为了您的账号安全建议您尽快绑定邮箱',
    bindAndLogin: '绑定邮箱并登陆',
    bindSuccess: '邮箱绑定成功',
    confirmUnbindTips: '解绑邮箱将增加您的账号安全风险，确定要解绑吗？',
    unbindSuccess: '邮箱解绑成功',
    sendcode: '发送验证码',
    sending: '发送中',
    loadingTextDefault: '正在载入...'
  },
  //和用户操作相关的按钮
  userCenter: {
    bLogin: '登录',
    bRegister: '注册',
    bForget: '忘记密码',
    confirmLogout: '您确定要退出吗？',
    cancelText: '取消',
    confirmText: '确定',
    update: '登录已过期，请您重新登录！',
    errorText: '请求出错了，请重试'
  },
  //首页
  indexPage: {
    tAllGames: '全部游戏',
    enterWebsite: '进入官网'
  },
  // 会员中心
  vipCenterPage: {
    sideNav: {
      base: '基本资料',
      bind: '绑定邮箱',
      unbind: '解绑邮箱',
      record: '记录查询',
      modify: '修改密码',
      signout: '退出登录'
    },
    breadcrumb: {
      current: '当前位置',
      aNavgation: '会员中心'
    },
    base: {
      myAccount: '我的账号',
      myIcons: '我的平台币',
      bind: '绑定邮箱',
      noBind: '邮箱尚未绑定'
    },
    bindTips:'提示：绑定邮箱后可以进行密码找回，修改密码操作 <br/> 为了您的账号安全建议尽快绑定邮箱。',
    unbindTips: '提示:通过绑定邮箱可以进行密码找回 <br/> 修改密码操作为了您的账号安全建议不要解绑邮箱。',
    totalFont: '总页数',
    rechargefail: '未支付', // -1
    rechargeSuccess: '充值成功', // 2
    testSuccess: '测试成功', // -3
    rechargeRecord: {
      noRecord: '您还没有任何充值记录，赶快去充值吧~',
      rechargeText: '去充值',
      title: '充值记录',
      orderId: '交易编码',
      payAmount: '充值金额',
      payState: '充值状态',
      payWay: '充值方式',
      payTime: '充值时间'
    },
    exchangeRecord: {
      noRecord: '您还没有任何兑换记录，赶快去兑换吧~',
      exchangText: '去兑换',
      title: '兑换记录',
      name: '游戏名称',
      server: '游戏服务器',
      exchangeAmount: '兑换金额',
      getAmount: '获得金额',
      exchangeTime: '兑换时间',
      rechangeTime: '充值时间'
    },
    modifySteps: {
      stepone: '验证安全信息',
      steptwo: '重置登录密码',
      stepthree: '密码重置成功'
    }
  },
  // 充值兑换
  recharge: {
    chooseGame: '请选择游戏',
    sideNav: {
      recharge: '账号充值',
      exchange: '兑换到游戏'
    },
    breadcrumb: {
      current: '当前位置',
      aNavgation: '充值兑换'
    },
    myIcons: '我的平台币',
    question: '充值遇到问题请联系客服',
    method: '充值方式',
    meal: '充值套餐',
    rechargeBtn: '充值',
    exchangeBtn: '确认兑换',
    chooseRole: '选择角色',
    gameHolder: '请选择游戏',
    serverHolder: '请选择服务器',
    roleHolder: '请选择游戏角色',
    noRole: '您在当前服务器中没有任何游戏角色，请更换其他服务器兑换',
    tips: '提示',
    noClose: '付款完成前请不要关闭此窗口，完成付款后请根据您的情况点击下面按钮：',
    choose: '请在新开页面完成付款后再选择',
    successBuy: '已完成付款',
    failBuy: '付款遇到问题',
    exchangeSuccess: '套餐兑换成功，快去登录游戏查看吧~',
    exchangeFail: '奇怪兑换竟然失败了，要不一会在试试？'
  },
  modify: {
    tips: '修改密码需要先绑定邮箱！',
    bindText: '绑定邮箱'
  },
  moblie: {
    registering: '注册中...',
    readFirst: '请先阅读用户注册协议',
    connectNav: '联系客服',
    agreement: '注册协议',
    unbindText: '解除绑定',
    bindText: '确认绑定',
    unbindTips: '通过绑定邮箱可以进行密码找回 <br/> 修改密码操作为了您的账号安全建议不要解绑邮箱。',
    bindTips:'绑定邮箱后可以进行密码找回，修改密码操作 <br/> 为了您的账号安全建议尽快绑定邮箱。',
    accountHolder: '请输入邮箱账号',
    topPullText: '下拉刷新',
    topDropText: '释放更新',
    topLoadingText: '加载中...',
    bottomPullText: '上拉加载',
    bottomDropText: "释放加载",
    bottomLoadingText: "加载中...",
    noMore: '没有更多了...',
    pleaseChoose: '请选择充值方式以及充值套餐',
    exchangeing: '兑换中...',
    forget: {
      stepone: '输入龙图账号',
      steptwo: '验证安全信息',
      stepthree: '重置登录密码',
      stepfour: '密码重置成功'
    }
  },
  order: {
    title: '订单确认',
    account: '充值账号',
    meal: '充值套餐',
    way: '支付方式',
    amount: '支付金额',
    cancelText: '取消',
    confirmText: '确认支付'
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js